import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Customer } from '@pos-app/data';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from '@pos-app/core-ui';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ExternalUser, ReportToUser } from '../../../manageusers/+state/user.model';
import { ManageusersPartialState } from '../../../manageusers/+state/manageusers.reducer';
import { ToastrService } from 'ngx-toastr';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { NgFor, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
@Component({
    selector: 'app-manage-partner-enrollment',
    templateUrl: './manage-partner-enrollment.component.html',
    styleUrls: ['./manage-partner-enrollment.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, CoreUiModule, NgFor, MatIcon, AsyncPipe]
})
export class ManagePartnerEnrollment implements OnInit {
  @ViewChild('content') modalBox: any;
  @Input() partnerProgrammeCode: string;
  @Input() partnerProgrammeName: string;
  selectedCustomer: Customer;
  updatePartnerEnrollmentForm: UntypedFormGroup;
  selectedCustomerName: string;
  selectedUserEmail: string = '';
  showResultUserSearchTable: boolean = false;
  formValid = false;
  userForms: UntypedFormGroup[] = [];
  private _customerEnrolledList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public customerEnrolledList$ = this._customerEnrolledList.asObservable();
  disabledUserSearch = new UntypedFormControl(false);
  private unSubscribe$ = new Subject<void>();
  reportToUserList: Array<ReportToUser> = [];
  newRegisteredEmail: string;
  registeredUserSearch = new UntypedFormControl('');
  minDate: NgbDateStruct;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private apiService: ApiService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.updatePartnerEnrollmentForm = this.formBuilder.group({
      selectedCustomerNumber: ['', Validators.required],
    });
    if ((this._customerEnrolledList.value || []).length === 0) {
      this.apiService.fetchPartnerProgrammeDetails({ programmeCode: this.partnerProgrammeCode }).subscribe((result) => {
        if (result) {
          this._customerEnrolledList.next(result.SearchResults.customersEnrolled || []);
        }
      });
    }
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onSelectUser(user: ExternalUser) {
    this.reset();
    this.selectedCustomer = null;
    this.selectedCustomerName = null;
    this.selectedUserEmail = user.email;

    if (user) {
      this.apiService
        .customerSearch({
          customerfuzzySearch: '',
          customerNumber: +user.parentCustomerNumber,
          customerType: '',
        })
        .pipe(map((result) => result?.SearchResults?.find((item) => +item.customerNumber === +user.parentCustomerNumber)))
        .subscribe((customer) => {
          if (customer) {
            this.selectCustomer(customer);
            this.selectedUserEmail = '';
          }
        });
    }
  }

  selectCustomer(e) {
    this.selectedCustomer = e;
    if (this.selectedCustomer) {
      if (this.selectedCustomer && this.selectedCustomer.customerNumber) {
        this.updatePartnerEnrollmentForm.patchValue({
          selectedCustomerNumber: this.selectedCustomer.customerNumber,
        });
      }
    }
  }

  reset() {
    this.updatePartnerEnrollmentForm.reset();
    this.selectedCustomer = null;
  }

  isFocus(e) {
    this.reset();
    this.showResultUserSearchTable = true;
    e.target.select();
  }

  delete(i) {
    const currentList = this._customerEnrolledList.value || [];
    const customerNumber = currentList[i]?.customerNumber;
    this.apiService
      .updateAccountCustomerSettings({
        partnerProgrammeCodes: [],
        customerNumber: customerNumber,
      })
      .subscribe((result) => {
        if (result.ErrorFlag === '0') {
          this.reset();
          const updated = currentList.filter((item, index) => index !== i);
          this._customerEnrolledList.next(updated);
          this.toastr.success('Partner deleted successfully');
        } else {
          this.toastr.error(result.ErrorMessage);
        }
      });
  }

  addPartnerToProgram() {
    if (this.updatePartnerEnrollmentForm.valid) {
      this.apiService
        .updateAccountCustomerSettings({
          partnerProgrammeCodes: this.partnerProgrammeCode,
          customerNumber: this.selectedCustomer.customerNumber,
        })
        .subscribe((result) => {
          if (result.ErrorFlag === '0') {
            this.toastr.success('Partner enrolled successfully');
            const current = this._customerEnrolledList.value || [];
            this._customerEnrolledList.next([
              ...current,
              {
                customerNumber: this.selectedCustomer.customerNumber,
                customerName: this.selectedCustomer.customerName,
              },
            ]);
            this.reset();
          } else {
            this.toastr.error(result.ErrorMessage);
          }
        });
    }
  }
}

